import { FC, useCallback, useMemo } from 'react';

import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import { useIngestionByDataSourceContext } from '../../../context/DataSourceIngestion.context';
import { IActiveIngestion } from 'Modules/Studio/components/StudioInfo/redux/ingestion.interface';
import IngestionButton from './IngestionButton';
import {
  getTableViewTableIsRunningIngestion,
  getTableViewTableIsDisabled,
  getTableViewTableTooltipText,
} from './helpers';

type TProps = Pick<IDataSourceItem, 'id' | 'name'> & {
  activeIngestion: IActiveIngestion | null;
};

const TableViewIngestionByTableButton: FC<TProps> = ({ id, name, activeIngestion }) => {
  const { runByTable, stopIngestion: stopIngestionById } = useIngestionByDataSourceContext();

  const isRunningIngestion: boolean = useMemo(
    () => getTableViewTableIsRunningIngestion(activeIngestion, name),
    [activeIngestion, name]
  );

  const isDisabled = useMemo(
    () => getTableViewTableIsDisabled(activeIngestion, name),
    [activeIngestion, name]
  );

  const toolTipText = useMemo(() => {
    return getTableViewTableTooltipText(isDisabled, isRunningIngestion, activeIngestion);
  }, [isDisabled, isRunningIngestion, activeIngestion]);

  /**
   * Start ingestion at table level
   */
  const startIngestion = useCallback(() => {
    runByTable({ dataSourceId: id, tableName: name });
  }, [runByTable, id, name]);

  /**
   * Stop ingestion at the table level
   */
  const stopIngestion = useCallback(() => {
    stopIngestionById(activeIngestion?.tables?.[name]?.ingestionId || '');
  }, [activeIngestion, stopIngestionById, name]);

  return (
    <IngestionButton
      id={id}
      isRunningIngestion={isRunningIngestion}
      isDisabled={isDisabled}
      toolTipText={toolTipText}
      startIngestion={startIngestion}
      stopIngestion={stopIngestion}
    />
  );
};

export default TableViewIngestionByTableButton;
